import { SensorStateType } from './state'

export interface SensorGettersType {
  getSensorById: (state: SensorStateType, id: string) => SensorStateType['sensor']
  getSensorByField: (state: SensorStateType, field: string) => SensorStateType['sensor']
  getSensorsByType: (state: SensorStateType, type: string) => SensorStateType['sensors']
}

export const SensorGetters = {
  getSensorById: (state: SensorStateType) => (id: string) => {
    return state.sensors.find(sensor => sensor.id === id)
  },
  getSensorByField: (state: SensorStateType) => (field: string) => {
    return state.sensors.find(sensor => sensor.field === field)
  },
  getSensorsByType: (state: SensorStateType) => (type: string) => {
    return state.sensors.filter(sensor => sensor.type === type)
  },
}
